/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { generateUUID } from '../utils';
import { ApiPayload } from '../model/api-payload.model';
import { PersistStorageKeys, PersistStorageService } from './persist-storage.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LoadPolicyDataParams } from '../model/save-calculation.model';
import AppError from '../model/app-error';

export enum ProcessType {
  TRIPABROAD = 'tripAbroad',
  TRAVELINPL = 'travelInPL',
  RESIGNATION = 'resignation',
}
@Injectable({
  providedIn: 'root',
})
export class ProcessService {
  private _sessionId: string;
  private _entryUrl: string;
  private _agentNumber?: string;
  private _helpModalVisible$ = new BehaviorSubject<boolean>(false);
  agentNumberFromToken$ = new Subject<string | undefined>();
  loadPolicyDataParams$ = new BehaviorSubject<LoadPolicyDataParams | null>(null);
  loadPolicyDataError$ = new BehaviorSubject<AppError | null>(null);

  constructor(private persistStorage: PersistStorageService, private router: Router) {
    const url = new URL(window.location.href);

    this._sessionId = this.createSession();
    this._entryUrl = url.href;
    this._agentNumber = this.preserveAgentNumber;
  }

  get preserveAgentNumber(): string | undefined {
    const url = new URL(window.location.href);

    const agentNumber = this.persistStorage.getString(PersistStorageKeys.AgentNumber) || url.searchParams.get('agentNumber') || undefined;

    if (agentNumber) {
      this.persistStorage.setString(PersistStorageKeys.AgentNumber, agentNumber, 'session');
    }

    return agentNumber;
  }

  get apiPayload(): ApiPayload {
    return {
      interactionData: {
        entryUrl: this._entryUrl,
        sessionId: this._sessionId,
        agentNumber: this._agentNumber,
      },
    };
  }

  get agentNumber(): string | undefined {
    return this._agentNumber === 'undefined' ? undefined : this._agentNumber;
  }

  get isNavigation(): boolean {
    return this.router.url.startsWith('/page/');
  }

  get helpModalVisible$(): Observable<boolean> {
    return this._helpModalVisible$.asObservable();
  }

  onPageInit(): void {
    const urlPath = location.hash.replace('#', '');

    this.persistStorage.setString(PersistStorageKeys.EntryUrl, urlPath, 'session');
  }

  setDiscountCode(discountCode: string): void {
    this.persistStorage.setString(PersistStorageKeys.DiscountCode, discountCode, 'session');
  }

  showHelpModal(): void {
    this._helpModalVisible$.next(true);
  }

  hideHelpModal(): void {
    this._helpModalVisible$.next(false);
  }

  setPolicyParams(params: LoadPolicyDataParams | null): void {
    this.loadPolicyDataParams$.next(params);
  }

  setPolicyDataError(error: AppError | null): void {
    this.loadPolicyDataError$.next(error);
  }

  clearPolicyParamsAndErrors() {
    this.loadPolicyDataParams$.next(null);
    this.loadPolicyDataError$.next(null);
  }

  private createSession(): string {
    const sessionId = this.persistStorage.getString(PersistStorageKeys.SessionID) || generateUUID();
    this.persistStorage.setString(PersistStorageKeys.SessionID, sessionId);

    return sessionId;
  }
}
